
(function ($) {
    $.fn.sgkModal = function (options) {
        var fg;
        var defaults = $.extend({
            title: "",
            target: "unknown",
            desktop: false
        }, options);

        this.each(function () {
            var div = $(this);
            var data = {};
            $.each(defaults, function (k, v) {
                if (typeof div.data(k) !== "undefined") {
                    data[k] = div.data(k);
                }
            });
            var settings = $.extend(Object.assign({}, defaults), data)

            if (settings.target !== "unknown") {
                div.on("click", function () {
                    if (settings.desktop || !$("#d-md").is(":visible")) {
                        $("#sgkModal").find('.modal-title').text(settings.title);
                        $("#sgkModal").modal('show');
                        //console.log('ajax');
                        $.ajax({
                            type: "POST",
                            url: "/Handler/ModalHandler.ashx",
                            data: {
                                modal: settings.target,
                                expert: div.data("expert"),
                                experttype: div.data("experttype")
                            },
                            dataType: 'html',
                            success: function (data) {
                                $("#sgkModal").find('.modal-body').html(data);
                                $(".sgkMore").sgkMore();
                            }
                        });
                    }
                })
            }
        });

        return this;
    };


}(jQuery));


